import { render, staticRenderFns } from "./CompanyModal.vue?vue&type=template&id=b95b942c"
import script from "./CompanyModal.vue?vue&type=script&lang=ts"
export * from "./CompanyModal.vue?vue&type=script&lang=ts"
import style0 from "./CompanyModal.vue?vue&type=style&index=0&id=b95b942c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports